import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface NavbarScrollContextType {
  scrolledContent: ReactNode | null;
  setScrolledContent: (content: ReactNode | null) => void;
}

const NavbarScrollContext = createContext<NavbarScrollContextType>({
  scrolledContent: null,
  setScrolledContent: () => {},
});

export const NavbarScrollProvider = ({ children }: { children: ReactNode }) => {
  const [scrolledContent, setScrolledContent] = useState<ReactNode | null>(null);
  const value = useMemo(
    () => ({ scrolledContent, setScrolledContent }),
    [scrolledContent],
  );
  return (
    <NavbarScrollContext.Provider value={value}>
      {children}
    </NavbarScrollContext.Provider>
  );
};

export const useNavbarScroll = () => useContext(NavbarScrollContext);
